import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation", "error"]

  validate() {
    const matches = this.confirmationTarget.value === "" || this.passwordTarget.value === this.confirmationTarget.value

    this.confirmationTarget.setCustomValidity(matches ? "" : "As senhas não coincidem")
    this.errorTarget.textContent = matches ? "" : "As senhas não coincidem"
    this.errorTarget.classList.toggle("hidden", matches)
    this.confirmationTarget.classList.toggle("border-red-500", !matches)
  }
}
